<template>
    <div id="Stops">

        <b-container fluid>
            <!-- <b-row class="mb-1 text-center"> -->
            <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
                <b-col sm="6">
                    <h1 class="labelBold">Reservar viaje </h1>
                </b-col>
            </b-row>
        </b-container>
        <b-row class="mt-5">
            <b-col cols="7">
                <div class="d-flex flex-row">
                    <FileUploader :placeholder="$t('menu.file_ph')" type=".csv" :label="$t('menu.browse')"
                        :fileUrl="fileUrl" @setFile="setFile" :clear="clear" />

                    <button @click="sendFileData()" :disabled="disabledButton" class="btn-AddStops button"><i
                            style='font-size:24px' class="fas fa-file-csv"></i> Subir
                        Archivo</button>
                    <span class=" ui-cursor-pointer" @click="showInf()">
                        <i style='font-size:24px' class='fas btn-outline-secondary'>&#xf05a;</i>
                    </span>
                </div>

            </b-col>
        </b-row>

        <b-row cols="2" cols-sm="4" cols-md="6" cols-lg="12" class="mt-5">

            <b-col cols="2">
                <label class="black">No. de control</label>
                <input class="form-control" type="text" id="schedule" placeholder="Buscar..."
                    v-model="createReservationSearch.controlNumber" @input="getUsersFilter" />
                <select v-if="controlNumberData.length > 0" class="form-control" id="schedule"
                    v-model="createReservation.data.controlNumber" @change="viewUserControl">
                    <option v-for="route in controlNumberData" :value="route.controlNumber">{{ route.controlNumber }}
                    </option>
                </select>
                <select class="form-control" v-if="controlNumberData.length == 0">
                    <option>Sin información</option>
                </select>
                <div class="error-msg" v-if="send && !createReservation.data.controlNumber">
                    <p>{{ $t("newInfo.errors.lat_req") }}</p>
                </div>

            </b-col>
            <b-col sm="2">
                <label class="black">Nombre</label>
                <input v-model="nameSelect" class="form-control noEditable" type="text" disabled />
            </b-col>
            <b-col sm="2">
                <label class="black">Apellido Paterno</label>
                <input v-model="lastnameSelect" class="form-control noEditable" type="text" disabled />
            </b-col>
            <b-col sm="2">
                <label class="black">Apellido Materno</label>
                <input v-model="motherslastnameSelect" class="form-control noEditable" type="text" disabled />
            </b-col>
            <b-col sm="2">
                <div class="dateInput">
                    <label class="black">Desde</label>
                    <br>
                    <date-picker class="dateInput" v-model="createReservation.data.bookingDate" placeholder="YYYY-MM-DD"
                        :disabled-date="disabledRange" value-type="format" format="YYYY-MM-DD">
                    </date-picker>
                    <div class="error-msg" v-if="send && !createReservation.data.bookingDate">
                        <p>{{ $t("newInfo.errors.lat_req") }}</p>
                    </div>

                </div>

            </b-col>
            <b-col sm="2">
                <div class="dateInput">
                    <label class="black">Hasta</label>
                    <br>
                    <date-picker class="dateInput" v-model="createReservation.data.bookingDateEnd"
                        placeholder="YYYY-MM-DD" :disabled-date="disabledRangeEnd" value-type="format"
                        format="YYYY-MM-DD">
                    </date-picker>

                </div>
            </b-col>

        </b-row>

        <b-row cols="2" cols-sm="4" cols-md="6" cols-lg="12" class="mt-5">
            <b-col cols="2">
                <label class="black">Dirección del viaje</label>
                <input class="form-control" type="text" id="schedule" placeholder="Buscar.."
                    v-model="createReservationSearch.bookingType" @input="getDireccionFilter" />
                <select v-if="objectDireccion.length > 0" class="form-control" id="schedule"
                    v-model="createReservation.data.bookingType">
                    <option v-for="direction in objectDireccion" :value="direction.value">{{ direction.text }}</option>
                </select>
                <select class="form-control" v-if="objectDireccion.length == 0">
                    <option>Sin información</option>
                </select>
                <div class="error-msg" v-if="send && !createReservation.data.bookingType">
                    <p>{{ $t("newInfo.errors.lat_req") }}</p>
                </div>
            </b-col>



            <b-col sm="2">
                <label class="black">Ruta</label>
                <input class="form-control" type="text" id="schedule" placeholder="Buscar.."
                    v-model="createReservationSearch.planningId" @input="getScheduleFilter" />
                <select v-if="routes.length > 0" class="form-control" id="schedule" @change="showSetStops"
                    v-model="createReservation.data.planningId">
                    <option v-for="route in routes" :value="route.planningId">{{ route.routeName }}</option>
                </select>
                <select class="form-control" v-if="routes.length == 0">
                    <option>Sin información</option>
                </select>
                <div class="error-msg" v-if="send && !createReservation.data.planningId">
                    <p>{{ $t("newInfo.errors.lat_req") }}</p>
                </div>
            </b-col>

            <b-col cols="2">
                <label class="black">Parada</label>
                <input class="form-control" type="text" id="schedule" placeholder="Buscar.."
                    v-model="createReservationSearch.parada" @input="getParadaFilter" />
                <select v-if="paradas.length > 0" class="form-control" id="schedule" @change="selectSetStops">
                    <option selected value="">Selecciona</option>
                    <option value="go" v-for="parada in paradas" :value="parada.stopId">{{ parada.stopName }}</option>
                </select>
                <select class="form-control" v-if="paradas.length == 0">
                    <option>Sin información</option>
                </select>
                <div class="error-msg" v-if="send && Object.keys(createReservation.data.stop).length == 0">
                    <p>{{ $t("newInfo.errors.lat_req") }}</p>
                </div>
            </b-col>
            <b-col cols="2">

            </b-col>
            <b-col cols="2">

            </b-col>
            <b-col cols="2">
                <button @click="saveReservation" class="btn-confirm btn-outline-secondary">
                    Reservar viaje
                </button>
            </b-col>
        </b-row>
        <br>
        <br>
        <br>
        <br>

      

        <v-server-table
      :columns="table_options.columns"
      :options="table_options.options"
      ref="userTable"
      fix-header>
      
      <!-- Updated -->
      <template v-slot:actions="props">
                <div class="actions">

                    <i @click="openEditModal(props)" class="icons-black far fa-edit"></i>
                </div>
       </template>
    </v-server-table>

        <Modal v-if="newModalActive" v-on:closeModal="closeModal">
            <div v-if="error">
                <b-alert v-model="error" variant="danger" dismissible id="alert-modal">{{ textoError }}</b-alert>
            </div>
            <!-- Modal title -->
            <template #header>
                <span class="title">Editar reserva</span>
            </template>
            <!-- Modal body -->
            <template>
                <b-row cols="12" class="mt-5">

                    <b-col cols="2">
                        <label class="black">No. de control</label>

                        <input class="form-control noEditable" type="text" disabled
                            v-model="editReservation.data.controlNumber" />
                    </b-col>

                    <b-col sm="2">
                        <label class="black">Nombre</label>
                        <input class="form-control noEditable" type="text" disabled v-model="nameSelectEdit" />
                    </b-col>
                    <b-col sm="2">
                        <label class="black">Apellido P.</label>
                        <input class="form-control noEditable" type="text" disabled v-model="lastnameSelectEdit" />
                    </b-col>
                    <b-col sm="2">
                        <label class="black">Apellido M.</label>
                        <input class="form-control noEditable" type="text" disabled
                            v-model="motherslastnameSelectEdit" />
                    </b-col>
                    <b-col sm="4">
                        <div class="dateInput">
                            <label class="black">Fecha</label>
                            <br>
                            <date-picker class="dateInput" v-model="editReservation.data.bookingDate"
                                placeholder="YYYY-MM-DD" value-type="format" format="YYYY-MM-DD"
                                :disabled-date="disabledRange">
                            </date-picker>
                            <div class="error-msg" v-if="!editReservation.data.bookingDate">
                                <p>{{ $t("newInfo.errors.lat_req") }}</p>
                            </div>

                        </div>

                    </b-col>

                </b-row>

                <b-row cols="12" class="mt-5">



                    <b-col cols="3">
                        <label class="black">Dirección del viaje</label>

                        <label class="form-control noEditable" type="text" disabled>{{
                            editReservation.data.bookingType == "go" ? 'Ida' : "Regreso" }}</label>
                    </b-col>


                    <b-col sm="3">
                        <label class="black">Ruta</label>
                        <input class="form-control" type="text" id="schedule" placeholder="Buscar.."
                            @input="getScheduleFilter" />
                        <select v-if="routes.length > 0" class="form-control" id="schedule" @change="showSetStops"
                            v-model="editReservation.data.planningId">
                            <option v-for="route in routes" :value="route.planningId">{{ route.routeName }}</option>
                        </select>
                        <select class="form-control" v-if="routes.length == 0">
                            <option>Sin información</option>
                        </select>
                    </b-col>




                    <b-col cols="3">
                        <label class="black">Parada</label>
                        <input class="form-control" type="text" id="schedule" placeholder="Buscar.."
                            @input="getParadaFilter" />
                        <select v-if="paradas.length > 0" class="form-control" id="schedule"
                            @change="selectSetStopsEdit" v-model="editReservation.data.stopId">
                            <option value="go" v-for="parada in paradas" :value="parada.stopId">{{ parada.stopName }}
                            </option>
                        </select>
                        <select class="form-control" v-if="paradas.length == 0">
                            <option>Sin información</option>
                        </select>
                    </b-col>


                    <b-col cols="3">
                        <button @click="openModalCancel" class="btn-confirm-modal ">
                            Cancelar viaje
                        </button>
                    </b-col>
                    <br>
                    <br>
                    <br>
                    <br>
                </b-row>
            </template>
            <!-- Modal footer -->
            <template #footer>
                <div class="modal-actions">
                    <span class="cancel-btn" @click="newModalActive = false">{{ $t("global.cancel") }}</span>
                    <button type="button" @click="updateReservation" class="btn btn-dark save-btn">{{ $t("global.save")
                        }}</button>
                </div>
            </template>
        </Modal>

        <Modal v-if="newModalActiveDelete" v-on:closeModal="closeModalDelete">
            <!-- Modal title -->
            <template #header>
                <span class="title">Cancelar viaje</span>
            </template>
            <!-- Modal body -->
            <template>
                <div class="form-container">
                    <!-- Name -->
                    <div class="input-container">
                        <label for="name">¿Deseas eliminar la reserva para {{ editReservation.data.controlNumber }} para
                            el día {{ editReservation.data.bookingDate }}?</label>
                        <div class="error-msg">
                        </div>
                    </div>

                </div>
            </template>
            <!-- Modal footer -->
            <template #footer>
                <div class="modal-actions">
                    <span class="cancel-btn" @click="newModalActiveDelete = false">{{ $t("global.cancel") }}</span>
                    <button type="button" class="btn btn-dark save-btn" @click="cancelReservation">Eliminar</button>
                </div>
            </template>
        </Modal>

        <b-modal size="lg" centered ref="my-info" scrollable :title="$t('bookingTransport.infoCsv')" tabindex="-1">
            <div>
                <p>
                    Archivo en formato .csv
                    <br />
                    <br>
                    Nombre de columnas: planningId (Ejemplo:0000)
                    <br />
                    <br />
                    Nombre de columnas: controlNumber (Ejemplo:000000)
                    <br />
                    <br />
                    Nombre de columnas: type (Ejemplo:go,back,round)
                    <br />
                    <br />
                    Nombre de columnas: dateStart (Ejemplo:aaaa-mm-dd)
                    <br />
                    <br />
                    Nombre de columnas: dateEnd (Ejemplo:aaaa-mm-dd)
                    <br />
                    <br />
                    Nombre de columnas: stopId (Ejemplo:P69)
                    <br />
                    <br />
                    Nombre de columnas: stopTime (Ejemplo:06:25)
                    <br />
                    <br />
                    Nombre de columnas: stopCoordenates (Ejemplo:"19.05946,-98.27656")
                    <br />
                    <br />
                    Nombre de columnas: stopDescription (Ejemplo:Descripción)
                    <br />
                    <br />
                    Nombre de columnas: routeId (Ejemplo:0000)
                    <br />
                    <br />
                    Nombre de columnas: routeDescription (Ejemplo:Descripción)
                    <br />
                </p>
            </div>


            <template #modal-footer>
                <div class="w-100">
                    <p class="float-left"></p>
                    <b-button size="lg" class="btn btn-dark float-right btn-xl" @click="DowloadLayout()">
                        {{ $t("bookingTransport.download") }}
                    </b-button>
                </div>
            </template>
        </b-modal>


        <b-modal size="lg" centered ref="my-infoError" scrollable :title="$t('bookingTransport.infoCsv')" tabindex="-1">
            <div class="d-flex flex-column">
                <span v-for="(fileError, index) in errores" :key="`fileError-${index}`">
                    {{ fileError }}
                </span>
            </div>


            <template #modal-footer>
                <div class="w-100">
                    <p class="float-left"></p>
                    <b-button size="lg" class="btn btn-dark float-right btn-xl" @click="$refs['my-infoError'].hide();">
                        Cerrar
                    </b-button>
                </div>
            </template>
        </b-modal>

    </div>
</template>

<script>
const ids = (value) => value != 0;
// import GoogleMapsApiLoader from 'google-maps-api-loader'
import { required, url, decimal } from "vuelidate/lib/validators";
import API_SERVICE from "@/lib/api/Booking.js";
import API_SERVICEUSERS from "@/lib/api/Users.js";
import store from '@/vuex/store';
const api = new API_SERVICE();
const apiUsers = new API_SERVICEUSERS();
import { ClientTable } from "vue-tables-2";
const Modal = () => import("@/components/Modal");
import FileUploader from "@/components/FileUploader";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-timepicker/dist/VueTimepicker.css";
import VueTimepicker from "vue2-timepicker";

import S3_Handler from "@/lib/api/s3_handler";
const s3 = new S3_Handler();

export default {

    components: {
        store,
        VueTimepicker,
        DatePicker,
        ClientTable,
        Modal,
        FileUploader

    },

    data: function () {
        return {
            disabledButton: true,
            fileUrl: null,
            file: null,
            errores: [],
            clear: false,
            newModalActiveDelete: false,
            send: false,
            objectDireccion: [
                { value: "go", text: "Viaje de ida" },
                { value: "back", text: "Viaje de regreso" },
                { value: "round", text: "Viaje redondo" }
            ],
            objectDireccionIntern: [
                { value: "go", text: "Viaje de ida" },
                { value: "back", text: "Viaje de regreso" },
                { value: "round", text: "Viaje redondo" }
            ],
            nameSelect: "",
            lastnameSelect: "",
            motherslastnameSelect: "",
            nameSelectEdit: "",
            lastnameSelectEdit: "",
            motherslastnameSelectEdit: "",
            controlNumberData: [],
            controlNumberDataIntern: [],
            filterRoute: '',
            textoError: "",
            valorTurno: {},
            error: false,
            newModalActive: false,
            paradasEdit: [],
            dates:
            {
                from: null,
                to: null,
            },
            routes: [],
            routesIntern: [],
            paradas: [],
            paradasIntern: [],
            arrayList: [],
            createReservation: {
                "action": "create",
                "data": {
                    "planningId": "",
                    "controlNumber": "",
                    "bookingType": "", // go, back, round
                    "bookingDate": "",
                    "bookingDateEnd": "",
                    "stop": {}
                }
            },
            createReservationSearch: {
                "parada": "",
                "planningId": "",
                "controlNumber": "",
                "bookingType": "", // go, back, round
                "bookingDate": this.formatoFecha(),
                "stop": {}
            },
            editReservation: {
                "action": "create",
                "data": {
                    "stopId": "",
                    "planningId": "",
                    "controlNumber": "",
                    "bookingType": "", // go, back, round
                    "bookingDate": this.formatoFecha(),
                    "stop": {}
                }
            }
        };
    },
    validations: {
        Stops: {
            id: {
                required
            },
            stop_name: {
                required
            },
            coordenates: {
                required,
                coord: function (coordinates) {
                    if (!coordinates.match(/^[-]?\d+[\.]?\d*, [-]?\d+[\.]?\d*$/)) {
                        return false;
                    }
                    const [latitude, longitude] = coordinates.split(",");
                    return (latitude > -90 && latitude < 90 && longitude > -180 && longitude < 180);
                }
            }
        },
        idRoute: {
            ids
        }
    },




    beforeMount: async function () {
        this.$store.commit("global/SET_LOADING", true);

        await this.getRutas();
       // await this.getList();
        await this.getUsersData();
        this.$store.commit("global/SET_LOADING", false);
    },

    computed: {
        userTableExtern: function () {
            return this.$refs.userTable;
        },
        table_options: function () {
            return {

                columns: [
                    "id",
                    "controlNumber",
                    "bookingDate",
                    "routeDescription",
                    "nombreRuta",
                    "stopDescription",
                    "actions"
                ],
                options: {
                    filterByColumn: true,//si
                    filterable: ["controlNumber"],//si
                    texts: {
                        filterBy: "{column}",
                        filter: `${this.$t("components.vue_tables.filter")}:`,
                        filterPlaceholder: this.$t("components.vue_tables.filter_ph")
                    },//si
                    headings: {
                        id: "Id",
                        controlNumber: "No. control",
                        bookingDate: "Fecha",
                        routeDescription: "Ruta",
                        nombreRuta: "Dirección",
                        stopDescription: "Parada",
                        actions: "Acciones"
                    },//si
                    sortable: [],
                    columnsClasses: {
                        title: "title-column",
                        report: "report-column",
                        actions: "actions-column",
                        updated_at: "updatedAt-column"
                    },//si
                    resizableColumns: false,//si
                    requestAdapter: function (data) {
                        const queries = {};
                        queries.page = data.page;
                        queries.limit = data.limit;
                        queries.query = data.query;


                        return queries;
                    },
                    requestFunction: async function (data) {
                        this.$store.commit("global/SET_LOADING", true);
                        try {
                            const dataFilter = { 
                                "action": "list_admin" ,
                                "filters": {
                                    "isCancelled": false,
                                    ...data.query
                                },
                                "pagination": {
                                    "all": false,
                                    "page":data.page,
	                                "limit": data.limit
                                }
                            }
//aqui
                           
                            const resp = await api.getRoutes(dataFilter);
                            for (let index = 0; index < resp.data.data.length; index++) {
                                resp.data.data[index].nombreRuta = resp.data.data[index].busDirection == "go" ? "Ida" : "Regreso";

                            }
                            this.$store.commit("global/SET_LOADING", false);
                            return resp;
                        } catch (error) {
                            this.$store.commit("global/SET_LOADING", false);
                            throw error;
                        }
                    },
                    responseAdapter: function (response) {
                        console.log("=================>",response.data);
                        
                        return {
                            data: response.data.data,
                            count: response.data.total,
                        };
                    },
                }
            };
        },
    },

    methods: {
        setFile: function async(fileData) {
            if (fileData) {
                this.file = fileData;
                if (this.file) {
                    this.disabledButton = false;
                } else {
                    this.disabledButton = true;
                }
            }

        },
        disabledRange: function (date) {
            return date < new Date();
        },
        disabledRangeEnd: function (date) {
            return date < new Date(this.createReservation.data.bookingDate)
        },
        async updateReservation() {
            if (!this.editReservation.data.bookingDate) {

            } else {
                this.$store.commit("global/SET_LOADING", true);
                try {
                    delete this.editReservation.data.stopId;
                    delete this.editReservation.data.stop.stopName;
                    this.editReservation.data.planningId = this.editReservation.data.planningId.toString();
                    const objectSend = { data: JSON.parse(JSON.stringify(this.editReservation.data)) }
                    await api.updateRoute(objectSend, this.valorTurno.id);
                    this.$store.commit("global/SET_LOADING", false);
                    this.$store.commit("global/SET_ALERT", {
                        msg: `Reserva actualizada`,
                        show: true,
                        type: "success"
                    });
                    this.newModalActive = false;
                    // this.getList();
                    this.userTableExtern.refresh();
                } catch (error) {

                    this.$store.commit("global/SET_LOADING", false);
                    this.$store.commit("global/SET_ALERT", {
                        msg: `${error.data.message}`,
                        show: true,
                        type: "error"
                    });
                    this.newModalActive = false;
                }
            }
        },
        esHoraValida: function (horaString) {
            const partes = horaString.split(':');
            const horas = parseInt(partes[0], 10);
            const minutos = parseInt(partes[1], 10);

            if (isNaN(horas) || isNaN(minutos)) {
                return false;
            }

            // Verificar rango de horas y minutos
            if (horas < 0 || horas > 23 || minutos < 0 || minutos > 59) {
                return false;
            }

            return true;
        },

        sendFileData: function async() {
            this.errores = [];
            this.clear = false;
            let csv = [];
            const reader = new FileReader();
            reader.readAsText(this.file)
            reader.onload = async (readerEvent) => {
                csv = JSON.parse(this.csvJSON(readerEvent.target.result));
                console.log("====", csv);

                let bandera = false;

                let banderacontrolNumber = false;
                let banderaplanningId = false;
                let banderastopTime = false;
                let banderastopId = false;
                let banderatype = false;
                let banderadateEnd = false;
                let banderadateStart = false;

                for (let index = 0; index < csv.length; index++) {
                    if (Object.keys(csv[index]).length > 3) {
                        const end = csv[index].dateEnd.split('-');
                        const start = csv[index].dateStart.split('-');

                        if (/^-?\d+$/.test(csv[index].controlNumber) == false && !banderacontrolNumber) {
                            bandera = true;
                            banderacontrolNumber = true;
                            this.errores.push("El campo controlNumber debe ser numerico en la fila " + ((index + 1)));
                        }
                        if (csv[index].planningId == "" && !banderaplanningId) {
                            bandera = true;
                            banderaplanningId = true;
                            this.errores.push("El campo planningId es requerido en la fila " + (index + 1));
                        }
                        if (!this.esHoraValida(csv[index].stopTime) && !banderastopTime) {
                            bandera = true;
                            banderastopTime = true;
                            this.errores.push("El campo stopTime no cumple con el formato requerido en la fila " + (index + 1));
                        }
                        if (csv[index].stopId == "" && !banderastopId) {
                            bandera = true;
                            banderastopId = true;
                            this.errores.push("El campo stopId es requerido en la fila " + (index + 1));
                        }
                        if (csv[index].type != "go" && csv[index].type != "back" && csv[index].type != "round" && !banderatype) {
                            bandera = true;
                            banderatype = true;
                            this.errores.push("El campo type no cumple con el formato requerido en la fila " + (index + 1));
                        }
                        if (end.length == 3 || start.length == 3 && !banderadateEnd && !banderadateStart) {
                            if (end[0].length != 4 || end[1].length != 2 || end[2].length != 2 && !banderadateEnd) {
                                bandera = true;
                                banderadateEnd = true;
                                this.errores.push("El campo dateEnd no cumple con el formato requerido en la fila " + (index + 1));
                            }
                            if (start[0].length != 4 || start[1].length != 2 || start[2].length != 2 && !banderadateStart) {
                                bandera = true;
                                banderadateStart = true;
                                this.errores.push("El campo dateStart no cumple con el formato requerido en la fila " + (index + 1));
                            }
                        } else {
                            if (end.length != 3) {
                                bandera = true;
                                banderadateEnd = true;
                                this.errores.push("Los campos campo dateEnd no cumple con el formato requerido en la fila " + (index + 1));
                            }
                            if (start.length != 3) {
                                bandera = true;
                                banderadateStart = true;
                                this.errores.push("Los campos campo dateStart no cumple con el formato requerido en la fila " + (index + 1));
                            }

                        }
                    }
                }
                if (bandera) {
                    this.clear = true;
                    this.$refs['my-infoError'].show();


                } else {
                    this.clear = false;
                    this.$store.commit("global/SET_LOADING", true);
                    try {
                        const timestamp = Date.now();
                        const fileData = `${timestamp}-amap-dbs-qa-app-files`;
                        const fileResp = await s3.uploadFile(fileData, this.file);
                        const { Bucket, Key, Location } = fileResp;
                        const dataResponse = await api.sendFile({ bucket: Bucket, key: Key });
                        this.$store.commit("global/SET_LOADING", false);
                        //await this.getList();
                        this.userTableExtern.refresh();
                        this.clear = true;
                        this.$store.commit("global/SET_ALERT", {
                            msg: "Archivo subido correctamente",
                            show: true,
                            type: "success"
                        });
                    } catch (err) {
                        this.clear = true;
                        this.$store.commit("global/SET_LOADING", false);
                        this.$store.commit("global/SET_ALERT", {
                            msg: err.data.message || "Error al subir el archivo",
                            show: true,
                            type: "error"
                        });

                    }

                }
            }
            /**/

        },
        getScheduleFilter(e) {
            if (e.target.value == "") {
                this.routes = this.routesIntern;
            } else {
                this.routes = this.routesIntern.filter((data) => data.routeName.toLowerCase().startsWith(e.target.value.toLowerCase()));
            }
        },
        getDireccionFilter(e) {
            if (e.target.value == "") {
                this.objectDireccion = this.objectDireccionIntern;
            } else {
                this.objectDireccion = this.objectDireccionIntern.filter((data) => data.text.toLowerCase().startsWith(e.target.value.toLowerCase()));
            }
        },
        getParadaFilter(e) {
            if (e.target.value == "") {
                this.paradas = this.paradasIntern;
            } else {
                this.paradas = this.paradasIntern.filter((data) => data.stopName.toLowerCase().startsWith(e.target.value.toLowerCase()));
            }
        },
        getUsersFilter(e) {
            if (e.target.value == "") {
                this.controlNumberData = this.controlNumberDataIntern;
            } else {
                this.controlNumberData = this.controlNumberDataIntern.filter((data) => data.controlNumber.toString().toLowerCase().startsWith(e.target.value.toString().toLowerCase()));
            }
        },
        openEditModal(data) {

            this.editReservation.data.controlNumber = data.row.controlNumber;
            this.editReservation.data.bookingType = data.row.busDirection;
            this.editReservation.data.bookingDate = data.row.bookingDate;
            this.editReservation.data.planningId = data.row.planningId;
            //this.showSetStopsEdit(data.row.planningId)
            this.showSetStops(data.row.planningId);
            const arrayStop = this.paradasIntern.filter(dataFilter => dataFilter.stopId == data.row.stopId);
            this.editReservation.data.stop = arrayStop[0];
            this.editReservation.data.stopId = data.row.stopId;
            this.viewUserControlEdit(data.row.controlNumber);
            this.valorTurno = data.row;
            this.controlNumberData = this.controlNumberDataIntern;
            this.newModalActive = true;
        },
        closeModal: function () {

            this.newModalActive = false;
        },
        closeModalDelete: function () {

            this.newModalActiveDelete = false;
        },
        showSetStops(e) {
            let filter = [];
            if (e.target) {
                filter = this.routes.filter(data => data.planningId == e.target.value);
            } else {
                filter = this.routes.filter(data => data.planningId == e);
            }


            if (filter.length == 1) {
                this.paradas = filter[0].stopsIds;
                this.paradasIntern = filter[0].stopsIds
            }
        },
        async viewUserControl(e) {
            this.$store.commit("global/SET_LOADING", true);
            const user = e.target ? e.target.value : e;
            const resp = await apiUsers.getFromArray({ "controlNumbers": [user] });
            this.nameSelect = resp.data[0].name;
            this.lastnameSelect = resp.data[0].lastname;
            this.motherslastnameSelect = resp.data[0].motherslastname;

            this.$store.commit("global/SET_LOADING", false);
        },
        async viewUserControlEdit(e) {
            this.$store.commit("global/SET_LOADING", true);
            const user = e.target ? e.target.value : e;
            const resp = await apiUsers.getFromArray({ "controlNumbers": [user] });

            this.nameSelectEdit = resp.data[0].name;
            this.lastnameSelectEdit = resp.data[0].lastname;
            this.motherslastnameSelectEdit = resp.data[0].motherslastname;

            this.$store.commit("global/SET_LOADING", false);
        },
        showSetStopsEdit(e) {
            let filter = this.routes.filter(data => data.planningId == e);
            if (filter.length == 1) {
                filter = JSON.parse(JSON.stringify(filter))
                delete filter[0].stopName;
                //this.paradasEdit = filter[0].stopsIds
                this.editReservation.data.stop = filter[0];
            }
        },
        selectSetStops(e) {
            if (e.target.value == "") {
                this.createReservation.data.stop = {};
            } else {
                let filter = this.paradas.filter(data => data.stopId == e.target.value);
                if (filter.length == 1) {
                    filter = JSON.parse(JSON.stringify(filter))
                    delete filter[0].stopName;
                    this.createReservation.data.stop = filter[0];
                }
            }
        },
        selectSetStopsEdit(e) {
            let filter = this.paradas.filter(data => data.stopId == e.target.value);




            if (filter.length == 1) {
                filter = JSON.parse(JSON.stringify(filter))
                delete filter[0].stopName;
                this.editReservation.data.stop = filter[0];
            }
        },
        csvJSON(csvText) {
            const lines = csvText.split('\n'); // Split into individual lines
            const result = [];
            const headers = lines[0].split(','); // Extract headers from the first line

            for (let i = 1; i < lines.length; i++) {
                const obj = {};
                const currentline = lines[i].split(','); // Split each line into values

                for (let j = 0; j < headers.length; j++) {
                    obj[headers[j]] = currentline[j]; // Map header to value
                }
                result.push(obj);
            }
            return JSON.stringify(result); // Convert the array of objects to a JSON string
        },
        async saveReservation() {
            if (!this.createReservation.data.controlNumber || !this.createReservation.data.bookingDate || !this.createReservation.data.bookingType || !this.createReservation.data.planningId || Object.keys(this.createReservation.data.stop).length == 0) {
                this.send = true;
            } else {
                this.send = false;
                if (this.createReservation.data.bookingDateEnd == "") {
                    delete this.createReservation.data.bookingDateEnd;
                }
                this.createReservation.data.planningId = this.createReservation.data.planningId.toString();
                const data = JSON.parse(JSON.stringify(this.createReservation));

                this.$store.commit("global/SET_LOADING", true);
                try {

                    const resp = await api.getRoutes(data);
                    // await this.getList();
                    this.userTableExtern.refresh();
                    this.$store.commit("global/SET_LOADING", false);
                    this.$store.commit("global/SET_ALERT", {
                        msg: "Reserva realizada correctamente",
                        show: true,
                        type: "success"
                    });
                    this.createReservation.data.controlNumber = "";
                    this.nameSelect = "";
                    this.lastnameSelect = "";
                    this.motherslastnameSelect = ""
                    this.createReservation.data.bookingDate = "";
                    this.createReservation.data.bookingDateEnd = "";
                    this.createReservation.data.bookingType = "";
                    this.createReservation.data.planningId = "";
                    this.paradas = [];

                    this.createReservationSearch.controlNumber = "";
                    this.createReservationSearch.bookingType = "";
                    this.createReservationSearch.planningId = "";
                    this.createReservationSearch.parada = "";
                }
                catch (eror) {

                    this.$store.commit("global/SET_LOADING", false);
                    this.$store.commit("global/SET_ALERT", {
                        msg: eror.data.message,
                        show: true,
                        type: "error"
                    });

                }
            }

        },
        openModalCancel() {
            this.newModalActiveDelete = true;
        },
        async cancelReservation() {
            if (!this.editReservation.data.bookingDate) {

            } else {
                const data = JSON.parse(JSON.stringify(this.valorTurno));
                const sendData = {
                    "action": "cancel",
                    "data": {
                        "controlNumber": data.controlNumber,
                        "bookingType": data.busDirection, // go, back, round
                        "bookingDate": data.bookingDate
                    }
                }
                this.$store.commit("global/SET_LOADING", true);
                try {

                    const resp = await api.getRoutes(sendData);
                    // await this.getList();

                    this.$store.commit("global/SET_LOADING", false);
                    this.$store.commit("global/SET_ALERT", {
                        msg: "Cancelación realizada correctamente",
                        show: true,
                        type: "success"
                    });
                    this.newModalActive = false;
                    this.newModalActiveDelete = false;
                    // this.getList();
                    this.userTableExtern.refresh();
                }
                catch (eror) {

                    this.$store.commit("global/SET_LOADING", false);
                    this.$store.commit("global/SET_ALERT", {
                        msg: eror.data.message,
                        show: true,
                        type: "error"
                    });
                    this.newModalActiveDelete = false;

                }
            }
        },
        formatoFecha() {
            const fecha = new Date();
            const año = fecha.getFullYear();
            const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Los meses son 0-indexados
            const dia = String(fecha.getDate()).padStart(2, '0');

            return `${año}-${mes}-${dia}`;
        },
        async getRutas() {
            this.$store.commit("global/SET_LOADING", true);
            try {
                const data = {
                    "pagination": { "all": true },
                    "action": "list_routes",
                    "filters": {
                        "dateFrom": this.formatoFecha(), // **camelCase**
                        "dateTo": this.formatoFecha(), // **camelCase**
                        "shift": "4",
                        "enabled": "true",
                    }
                }
                const resp = await api.getRoutes(data);
                this.routes = resp.data.data;
                this.routesIntern = resp.data.data;
                this.$store.commit("global/SET_LOADING", false);
            }
            catch (eror) {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                    msg: eror,
                    show: true,
                    type: "error"
                });

            }
        },
        async getUsersData() {
            this.$store.commit("global/SET_LOADING", true);
            let data = {
                page: 0,
                limit: 25,
                query: {},
                all: true,
            };
            const resp = await apiUsers.getUsers(data);
            this.controlNumberDataIntern = resp.data;
            this.controlNumberData = resp.data;

            this.$store.commit("global/SET_LOADING", false);
        },
        async getList() {
            this.$store.commit("global/SET_LOADING", true);
            try {
                const data = {
                    "action": "list",
                    "filters": {
                        //"controlNumber": "222230" // TODO Ha sido modificada de user_control_number a controlNumber
                        // "isCancelled": true,
                        // "planningId": "489",
                        // "bookingDate": "2025-05-21"
                    },
                    "pagination": {
                        "all": true

                    }
                }
                const resp = await api.getRoutes(data);
                for (let index = 0; index < resp.data.data.length; index++) {
                    resp.data.data[index].nombreRuta = resp.data.data[index].busDirection == "go" ? "Ida" : "Regreso";

                }
                console.log("==============", resp.data.data);

                this.arrayList = resp.data.data;

                this.$store.commit("global/SET_LOADING", false);
            }
            catch (eror) {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                    msg: eror,
                    show: true,
                    type: "error"
                });

            }
        },

        DowloadLayout() {
            try {

                let anchor = document.createElement("a");
                anchor.href = "https://817467424320-amap-dbs-qa-app-files.s3.ca-central-1.amazonaws.com/booking/reservations/reservations_layout_example.csv";
                anchor.target = "_blank";
                anchor.click();

                this.$refs['my-info'].hide();
                this.$store.commit("global/SET_ALERT", {
                    msg: this.$t("bookingTransport.dowloaded"),
                    show: true,
                    type: "success"
                });

            }
            catch (error) {
                this.$store.commit("global/SET_ALERT", {
                    msg: error,
                    show: true,
                    type: "error"
                });
            }
        },

        translateStatus(id) {
            var TranslateSchedule = [];
            TranslateSchedule = this.arraySchedule.filter((e) => e.id == id);
            return TranslateSchedule[0].shift_name;
        },

        EditScheduleHour: function () {
            try {
                if (this.timeStop >= this.ScheduleValidate.start_time && this.timeStop <= this.ScheduleValidate.end_time) {
                    const pos = this.tableDataSchedule.map(e => e.id).indexOf(this.EditIdSchedule);
                    this.tableDataSchedule.splice(pos, 1, {
                        id: this.EditIdSchedule,
                        schedule: this.timeStop
                    });
                    this.timeStop = '00:00';
                    this.idSchedule = null;
                    this.ScheduleValidate.shift_name = '';
                    this.ScheduleValidate.start_time = '00:00';
                    this.ScheduleValidate.end_time = '00:00';

                    this.$store.commit("global/SET_ALERT", {
                        msg: `${this.$t("bookingTransport.update")}`,
                        show: true,
                        type: "success"
                    });

                    this.$refs['my-editHour'].hide();
                }
                else if (this.ScheduleValidate.end_time <= this.ScheduleValidate.start_time) {

                    if ((this.timeStop >= this.ScheduleValidate.start_time) || (this.timeStop >= '00:00' && this.timeStop <= this.ScheduleValidate.end_time)) {

                        const pos = this.tableDataSchedule.map(e => e.id).indexOf(this.EditIdSchedule);
                        this.tableDataSchedule.splice(pos, 1, {
                            id: this.EditIdSchedule,
                            schedule: this.timeStop
                        });
                        this.timeStop = '00:00';
                        this.idSchedule = null;
                        this.ScheduleValidate.shift_name = '';
                        this.ScheduleValidate.start_time = '00:00';
                        this.ScheduleValidate.end_time = '00:00';

                        this.$store.commit("global/SET_ALERT", {
                            msg: `${this.$t("bookingTransport.update")}`,
                            show: true,
                            type: "success"
                        });

                        this.$refs['my-editHour'].hide();
                        return;


                    }
                    else {
                        this.$store.commit("global/SET_ALERT", {
                            msg: `${this.$t("bookingTransport.Nocorresponds")}`,
                            show: true,
                            type: "error"
                        });
                    }
                }
                else {
                    this.$store.commit("global/SET_ALERT", {
                        msg: `${this.$t("bookingTransport.Nocorresponds")}`,
                        show: true,
                        type: "error"
                    });

                }
            }
            catch (error) {
                this.$store.commit("global/SET_ALERT", {
                    msg: error,
                    show: true,
                    type: "error"
                });

            }

        },

        DeleteScheduleData: function (data, action) {

            try {
                this.$store.commit("global/SET_LOADING", true);
                if (action) {
                    var ValidateSchedule = [];
                    ValidateSchedule = this.arraySchedule.filter((e) => e.id == data.id);
                    this.DeleteIdSchedule = data.id;
                    this.Delteshift_name = ValidateSchedule[0].shift_name;
                    this.DeleteSchedule = data.schedule;
                    this.$refs['my-delete'].show();
                    this.$store.commit("global/SET_LOADING", false);
                    return;
                }

                if (data == "Delete") {
                    const pos = this.tableDataSchedule.map(e => e.id).indexOf(this.DeleteIdSchedule);
                    this.tableDataSchedule.splice(pos, 1);
                    this.$store.commit("global/SET_ALERT", {
                        msg: `${this.$t("bookingTransport.planning.deleteSuccess")}`,
                        show: true,
                        type: "success"
                    });
                    this.$refs['my-delete'].hide();


                    this.timeStop = '00:00';
                    this.idSchedule = null;
                    this.ScheduleValidate.shift_name = '';
                    this.ScheduleValidate.start_time = '00:00';
                    this.ScheduleValidate.end_time = '00:00';
                    this.$store.commit("global/SET_LOADING", false);
                    return;
                }
            }
            catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                    msg: error,
                    show: true,
                    type: "error"
                });

            }
        },



        ModifySchedule: function (data, action) {
            try {
                this.$store.commit("global/SET_LOADING", true);
                this.ValidateScheduleEdit = this.arraySchedule.filter((e) => e.id == data.id);
                this.ScheduleValidate.shift_name = this.ValidateScheduleEdit[0].shift_name;
                this.ScheduleValidate.start_time = this.ValidateScheduleEdit[0].start_time;
                this.ScheduleValidate.end_time = this.ValidateScheduleEdit[0].end_time;
                this.idSchedule = data.id;
                this.EditIdSchedule = data.id;
                this.timeStop = data.schedule;
                this.$store.commit("global/SET_LOADING", false);
                this.$refs['my-editHour'].show();

            }
            catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                    msg: error,
                    show: true,
                    type: "error"
                });
            }

        },


        getRoutes: async function () {
            this.$store.commit("global/SET_LOADING", true);
            try {
                const queries = {};
                queries.catalogType = "routes"
                queries.pagination = {
                    all: false,
                    limit: 300,
                    page: 1
                };
                queries.filters = {
                    route_name: this.filterRoutes
                };
                const resp = await api.getLists(queries);
                this.arrayRutas = resp.data;
                this.$store.commit("global/SET_LOADING", false);
            }
            catch (eror) {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                    msg: eror,
                    show: true,
                    type: "error"
                });

            }
        },
        getSchedule: async function () {
            this.$store.commit("global/SET_LOADING", true);
            try {
                const queries = {};
                queries.action = "list"
                queries.pagination = {
                    all: false,
                    limit: 300,
                    page: 1
                };
                queries.filters = { shift_name: this.filterSchedule };
                const resp = await api.getSchedule(queries);
                this.arraySchedule = resp.data;
                this.$store.commit("global/SET_LOADING", false);
            }
            catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                    msg: error.response.data.error,
                    show: true,
                    type: "error"
                });

            }
        },
        updateTable: function () {
            this.routesTable.refresh();
        },

        Upload: async function () {
            await this.uploadFile();
        },

        uploadFile: async function () {
            try {

                if (this.filelocation) {
                    this.$store.commit("global/SET_LOADING", true);
                    var json = {
                        upload_type: "stops",
                        url: this.filelocation
                    }
                    const resp = await api.uploadFile(json);
                    if (resp.message == "Datos insertados correctamente.") {
                        this.filelocation = null;
                        this.filePlatform = null;
                        this.file = false;
                        this.fileOk = false;
                        document.getElementById("file-2").value = "";
                        document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");
                        this.$store.commit("global/SET_ALERT", {
                            msg: this.$t("bookingTransport.success"),
                            show: true,
                            type: "success"
                        });
                    }
                    else {
                        this.$store.commit("global/SET_ALERT", {
                            msg: resp.error,
                            show: true,
                            type: "error"
                        });
                    }
                    this.updateTable();
                    this.$store.commit("global/SET_LOADING", false);
                }
            } catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                    msg: error.response.data.message,
                    show: true,
                    type: "error"
                });
                // if(error.response.data.hasOwnProperty('err')){

                //   console.log(error);
                //   // this.backendError = error.response.data.err.replace(': ', ':<br>').replace(/required.,/g, 'required.<br>');
                //   this.backendError = error.response.data.err.replace('.', ' ').replace(/required.,/g, 'required.</br>').replace("\n", "<br/>");
                //   this.$refs['my-info'].show();

                // }
                // this.alert.status = 'error';
                // this.loadingFile = false;
                throw error;
            }
        },


        Modify: function (data) {

            try {

                this.$store.commit("global/SET_LOADING", true);
                this.nuevo = false;
                this.filterRoutes = "";
                this.tableDataSchedule = [];
                this.Stops.id = data.id;
                this.Stops.stop_name = data.stop_name;
                this.Stops.coordenates = data.coordenates;
                this.Stops.schedule = data.schedule;
                this.enableStop = data.enabled;
                this.idRoute = data.route_id;
                this.old_route_id = data.route_id;
                var schedule = data.schedule;
                for (var prop in schedule) {
                    if (schedule.hasOwnProperty(prop)) {
                        var json = {
                            id: prop,
                            schedule: schedule[prop]
                        };
                        this.tableDataSchedule.push(json);
                    }
                }
                this.$refs['my-edit'].show();
                this.$store.commit("global/SET_LOADING", false);
            }
            catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                    msg: error.response.data.error,
                    show: true,
                    type: "error"
                });
            }

        },


        loadCSV: async function (e) {

            try {
                this.$store.commit("global/SET_LOADING", true);
                this.filePlatform = e.target.files[0];
                document.getElementById('filecsv').textContent = e.target.files[0].name;
                const timestamp = Date.now();
                let Type = "Stops";
                const file = `Booking/${Type}/${timestamp}_${Type}.csv`;
                const fileResp = await s3.uploadFile(file, this.filePlatform);
                const { Location } = fileResp;
                this.filelocation = Location;
                this.file = true;
                var json = {
                    upload_type: "stops",
                    url: Location
                }
                const resp = await api.validate(json)
                this.$store.commit("global/SET_LOADING", false);

                const copyErrors = resp.errors.filter(message => !message.includes('ya existe en la base de datos'))

                if (resp.message == "Datos fueron validados correctamente." || copyErrors.length === 0) {

                    this.fileOk = true;
                    this.$store.commit("global/SET_ALERT", {
                        msg: this.$t("bookingTransport.Routes.ready"),
                        show: true,
                        type: "success"
                    });

                }
                else {
                    this.$refs['my-error'].show();
                    const backendError = resp.errors.toString().replace(/,/g, '\n');
                    // var backendError1 = backendError.toString().replace(/,/g, '\n');
                    // alert(backendError.toString());
                    //const backendError = error.response.data.err.replace('.', ' ').replace(/required.,/g, 'required.</br>').replace("\n", "<br/>");
                    //this.error = resp.errors;
                    // this.error = backendError.toString();
                    this.error = backendError;
                }
            }
            catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                    msg: error.response.data.error,
                    show: true,
                    type: "error"
                });
            }
        },

        showInf: function () {
            this.$refs['my-info'].show();
        },

        removeFile: function () {

            try {
                this.$store.commit("global/SET_LOADING", true);
                this.filelocation = null;
                this.filePlatform = null;
                this.file = false;
                this.fileOk = false;
                document.getElementById("file-2").value = "";
                document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");
                this.$store.commit("global/SET_ALERT", {
                    msg: this.$t("bookingTransport.filedelete"),
                    show: true,
                    type: "success"
                });
                this.$store.commit("global/SET_LOADING", false);
            }
            catch (error) {

                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                    msg: error,
                    show: true,
                    type: "error"
                });

            }
        },
        showModalCreate() {

            try {
                this.$store.commit("global/SET_LOADING", true);
                this.nuevo = true;
                this.Stops.id = '';
                this.Stops.stop_name = '';
                this.Stops.coordenates = '';
                this.idRoute = 0
                this.idSchedule = 0
                this.filterRoutes = "";
                this.timeStop = '';
                this.ScheduleValidate.shift_name = '';
                this.ScheduleValidate.start_time = '';
                this.ScheduleValidate.end_time = '';
                this.tableDataSchedule = [];
                this.$refs['my-edit'].show();
                this.$store.commit("global/SET_LOADING", false);
            }
            catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                    msg: error,
                    show: true,
                    type: "error"
                });

            }
        },
        closeDelete() {
            this.timeStop = '00:00';
            this.idSchedule = 0;
            this.ScheduleValidate.shift_name = '';
            this.ScheduleValidate.start_time = '00:00';
            this.ScheduleValidate.end_time = '00:00';
            this.$refs['my-delete'].hide();
        },
        closeEdit() {
            this.$refs['my-edit'].hide();
        },
        closeEditHour() {
            this.timeStop = '00:00';
            this.idSchedule = null;
            this.ScheduleValidate.shift_name = '';
            this.ScheduleValidate.start_time = '00:00';
            this.ScheduleValidate.end_time = '00:00';
            this.$refs['my-editHour'].hide();
        },


        EditConfirm: async function (action) {
            this.$v.$touch();
            if (this.$v.$error) return;
            try {
                this.$store.commit("global/SET_LOADING", true);
                var arraySchedule = this.tableDataSchedule;
                var JsonSchedule = {}

                arraySchedule.forEach((data, index) => {
                    var idx = data.id;
                    var ScheduleX = data.schedule;
                    JsonSchedule[idx] = ScheduleX;
                });
                var json = {
                    id: this.Stops.id,
                    route_id: this.idRoute,
                    stop_name: this.Stops.stop_name,
                    coordenates: this.Stops.coordenates,
                    schedule: JsonSchedule,
                    enabled: this.enableStop
                }

                var resp = null;
                if (this.nuevo == true) {
                    resp = await api.StopsNew({ catalogType: "stops", values: json });
                    //resp = await api.StopsEdit({catalogType: "stops",values:json});
                }
                else {

                    var json2 = {
                        id: this.Stops.id,
                        route_id: this.idRoute,
                        old_route_id: this.old_route_id,
                        stop_name: this.Stops.stop_name,
                        coordenates: this.Stops.coordenates,
                        schedule: JsonSchedule,
                        enabled: this.enableStop
                    }
                    resp = await api.StopsEdit({ catalogType: "stops", values: json2 });
                    //resp = await api.StopsNew({catalogType: "stops",values:json});
                }
                if (resp.message == "Los datos se actualizaron correctamente.") {
                    this.$store.commit("global/SET_ALERT", {
                        msg: this.$t("bookingTransport.Stops.updated"),
                        show: true,
                        type: "success"
                    });
                }
                else if (resp.message == "Datos creados correctamente.") {
                    this.$store.commit("global/SET_ALERT", {
                        msg: this.$t("bookingTransport.Stops.create"),
                        show: true,
                        type: "success"
                    });
                }
                this.$v.$reset();
                this.$refs['my-edit'].hide();
                this.updateTable();
                this.$store.commit("global/SET_LOADING", false);

            }

            catch (error) {
                this.$refs['my-error'].show();
                const backendError = error.toString().replace(/,/g, '\n');
                this.error = backendError;
            }

        },
        AddSchedule() {
            var ValidateSchedule = [];
            ValidateSchedule = this.tableDataSchedule.filter((e) => e.id == this.idSchedule);
            if (ValidateSchedule.length > 0) {
                this.$store.commit("global/SET_ALERT", {
                    msg: this.$t("bookingTransport.ScheduleExist"),
                    show: true,
                    type: "error"
                });
                return;
            }
            else if (this.idSchedule == null || this.idSchedule == 0) {
                this.$store.commit("global/SET_ALERT", {
                    // msg: `${this.$t("bookingTransport.planning.falseSchedule")}`,
                    msg: this.$t("bookingTransport.selectSchedule"),
                    show: true,
                    type: "error"
                });
                return;

            }
            else {

                if (this.timeStop >= this.ScheduleValidate.start_time && this.timeStop <= this.ScheduleValidate.end_time) {
                    var json = {
                        id: this.idSchedule,
                        schedule: this.timeStop
                    };
                    this.tableDataSchedule.push(json);
                    this.$store.commit("global/SET_ALERT", {
                        msg: this.$t("bookingTransport.AddSchedule"),
                        show: true,
                        type: "success"
                    });
                    this.timeStop = '00:00';
                    this.idSchedule = null;
                    this.ScheduleValidate.shift_name = '';
                    this.ScheduleValidate.start_time = '00:00';
                    this.ScheduleValidate.end_time = '00:00';
                    return;
                }
                else if (this.ScheduleValidate.end_time <= this.ScheduleValidate.start_time) {
                    if ((this.timeStop >= this.ScheduleValidate.start_time) || (this.timeStop >= '00:00' && this.timeStop <= this.ScheduleValidate.end_time)) {
                        var json = {
                            id: this.idSchedule,
                            schedule: this.timeStop
                        };
                        this.tableDataSchedule.push(json);
                        this.$store.commit("global/SET_ALERT", {
                            msg: this.$t("bookingTransport.AddSchedule"),
                            show: true,
                            type: "success"
                        });
                        this.timeStop = '00:00';
                        this.idSchedule = null;
                        this.ScheduleValidate.shift_name = '';
                        this.ScheduleValidate.start_time = '00:00';
                        this.ScheduleValidate.end_time = '00:00';
                        return;


                    } else {
                        this.$store.commit("global/SET_ALERT", {
                            msg: `${this.$t("bookingTransport.planning.falseSchedule")}`,
                            show: true,
                            type: "error"
                        });
                        return;


                    }

                }

                else {
                    this.$store.commit("global/SET_ALERT", {
                        msg: `${this.$t("bookingTransport.planning.falseSchedule")}`,
                        show: true,
                        type: "error"
                    });
                }
                return;
            }
        }

    },

}



</script>

<style lang="scss">
#Stops {
    background-color: $white;
    padding: 2rem 4rem;


}

.noEditable {
    background-color: #e4e7ea !important;
    font-stretch: normal;
    font-style: normal;
    font-variant: normal;
    font-weight: bold;
    letter-spacing: normal;
    line-height: normal;
    text-decoration: none;
    text-transform: none;
}

.btn-confirm {
    padding: 0.5rem 0.5rem;
    background: #000;
    color: #fff;
    border: 1px solid #000;
    border-radius: 0px;
    font-size: 16px;
    // height: 48px;
    width: 162px;
}

.btn-confirm-modal {
    margin-top: 20px;
    padding: 0.5rem 0.5rem;
    background: white;
    color: black;
    border: 1.5px solid black;
    border-radius: 0px;
    font-size: 16px;
    // height: 48px;
    width: 162px;
}

.title {
    font-weight: bold;
    font-size: 1.9rem;
}

.mx-datepicker {
    max-width: 100% !important;
}

.modal-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    >* {
        margin-left: 1rem;
        cursor: pointer;
    }

    .cancel-btn {
        &:hover {
            text-decoration: underline;
        }
    }

    .save-btn {
        margin: 0 0 0 10px;
        color: white;
        background-color: black;
        border-color: black;
        padding: 10px 20px;
        border-radius: 0px;
        transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
    }
}

.error-msg {
    color: $warn_red;
    font-size: 14px;
}

.btn-AddStops {

    background: #000;
    color: #fff;
    border: 1px solid #000;
    border-radius: 0px;
    font-size: 14px;
    min-width: max-content;
    padding: 5px 25px !important;
    margin-left: 15px;
}

.button {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}
</style>